import { apiClient } from "./apiClient";

export const notificationsApi = {
  todayBriefing: () => apiClient.get("/notifications/today-briefing").then((r) => r.data),
  snooze: (notificationType, snoozeMinutes = 1440) =>
    apiClient.post("/notifications/snooze", { notification_type: notificationType, snooze_minutes: snoozeMinutes }).then((r) => r.data),
};
